import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-subscribe',
    templateUrl: './subscribe.component.html',
    styleUrls: ['./subscribe.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubscribeComponent implements OnInit {

  constructor(private viewportScroller: ViewportScroller, 
    private toastr: ToastrService,
    private translate: TranslateService) {}

  public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit() {
  }


  suscribe(form: { email?: string }){
    if(form.email){
      setTimeout(() => {
        this.toastr.success(this.translate.instant('subscribe.success'));
      }, 300);
    }else{
      this.toastr.warning(this.translate.instant('subscribe.warning'));
    }

  }

}
